<mat-form-field
    [formGroup]="formGroup"
    class="w-full"
    [subscriptSizing]="'dynamic'"
    appearance="outline"
>
    @if(slot.label){
        <mat-label class="h-[30px] text-[14px] font-medium text-[000000BF] opacity-80 flex block">{{ slot.label }}</mat-label>
    }
    
    <mat-select
        [formControlName]="slot.field"
        multiple
        class="w-full"
        (selectionChange)="onSelectionChange($event)"
    >
        <mat-select-trigger>
            @if (selectedValues.length === 0) {
                <span class="text-gray-400"></span>
            } @else {
                <div class="flex flex-wrap items-center gap-1">
                    @for (value of selectedValues.slice(0, 2); track value) {
                        <mat-chip class="text-xs h-4 px-0 m-0 flex items-center justify-center">
                            {{ getDisplayLabel(value) }}
                            <button matChipRemove (click)="removeValue(value)" class="w-2 h-2"></button>
                        </mat-chip>
                    }
                    @if (selectedValues.length > 2) {
                        <span class="text-m text-gray-600">(+{{ selectedValues.length - 2 }})</span>
                    }
                </div>
            }
        </mat-select-trigger>
        
        @for (option of slot.options; track option) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
    </mat-select>
</mat-form-field> 